import { formatDurationHoursMinutes } from "./attendancePunchDisplay";

const EMPTY = "—";

function stripHtml(html) {
  if (!html) return "";
  return String(html)
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function extraFieldHasContent(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return false;
  if (raw === "<p><br></p>" || raw === "<p></p>") return false;
  return stripHtml(raw).length > 0;
}

function buildExtrasFields(raw) {
  const source = raw && typeof raw === "object" ? raw : {};
  return {
    inProgressTasks: String(source.inProgressTasks ?? "").trim(),
    plannedForTomorrow: String(source.plannedForTomorrow ?? "").trim(),
    issueBlocker: String(source.issueBlocker ?? "").trim(),
    dependency: String(source.dependency ?? "").trim(),
    supportRequiredFrom: String(source.supportRequiredFrom ?? "").trim(),
    meetingsDiscussions: String(source.meetingsDiscussions ?? "").trim(),
    clientFeedback: String(source.clientFeedback ?? "").trim(),
    deploymentNotes: String(source.deploymentNotes ?? "").trim(),
  };
}

function getTaskMinutes(task) {
  const hours = task.durationHours?.value
    ? parseInt(task.durationHours.value, 10)
    : 0;
  const minutes = task.durationMinutes?.value
    ? parseInt(task.durationMinutes.value, 10)
    : 0;
  return hours * 60 + minutes;
}

export function buildDailyHoursViewMailSubject({ date }) {
  return `Daily work updates — ${String(date || "").trim()}`;
}

/** Plain-text body for daily work updates email. */
export function buildDailyHoursViewMailPlainText({ tasks = [], dailyExtras = {}, adminName }) {
  const lines = tasks.map((task, i) => {
    const projectName =
      task.selectedProject?.label || `Project #${task.selectedProject?.value || "?"}`;
    const dur = formatDurationHoursMinutes(getTaskMinutes(task));
    const desc = stripHtml(task.taskDescription);
    const cat = task.prjCategory?.label || task.prjCategory?.value || "";
    return `${i + 1}. ${projectName}${cat ? ` — ${cat}` : ""} — ${dur}\r\n   ${desc || "(no description)"}`;
  });

  const extras = buildExtrasFields(dailyExtras);
  const formatExtra = (v) => (extraFieldHasContent(v) ? stripHtml(v) : EMPTY);

  return [
    ...lines,
    "",
    "Tasks",
    `In-progress tasks: ${formatExtra(extras.inProgressTasks)}`,
    `Planned for tomorrow: ${formatExtra(extras.plannedForTomorrow)}`,
    "",
    "Blockers / Dependencies",
    `Issue / Blocker: ${formatExtra(extras.issueBlocker)}`,
    `Dependency: ${formatExtra(extras.dependency)}`,
    `Support Required From: ${formatExtra(extras.supportRequiredFrom)}`,
    "",
    "Notes / Additional Updates",
    `Meetings attended / discussions: ${formatExtra(extras.meetingsDiscussions)}`,
    `Client feedback: ${formatExtra(extras.clientFeedback)}`,
    `Deployment updates or important notes: ${formatExtra(extras.deploymentNotes)}`,
    "",
    "Best regards,",
    String(adminName || "").trim() || "Admin",
  ].join("\r\n");
}
